import { useEffect } from "react";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import init from "../../firebase";

const Logout = () => {
  const auth = init.auth;
  const navigate = useNavigate();

  useEffect(() => {
    const handleLogout = async () => {
      try {
        await signOut(auth);
        navigate("/");
      } catch (error) {
        console.error("Logout failed:", error);
      }
    };

    handleLogout();
  }, [auth, navigate]);

  return null; // important
};

export default Logout;